import type {
  ExtendedWhatsAppTemplateMessageParams,
  WhatsAppTemplateDraft,
} from '../types/whatsapp-template-send.types';
import { buildTemplateMessageFromComponents } from './whatsapp-template.util';

/**
 * Builds an HTTP request and its local rendered text from submitted form values.
 * @param draft - Template, parameters and participants selected in the form.
 * @returns Generated request fields with local rendering context.
 */
export const buildWhatsAppTemplateSendParams = (
  draft: WhatsAppTemplateDraft
): ExtendedWhatsAppTemplateMessageParams => ({
  fromPhoneNumber: draft.fromPhoneNumber,
  toPhoneNumber: draft.toPhoneNumber,
  templateName: draft.template.name,
  languageCode: draft.template.language,
  components: draft.components,
  optimisticData: {
    content: buildTemplateMessageFromComponents(
      draft.template,
      draft.components
    ),
  },
});
